import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcCloseBold = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#13151A",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M7.057 7.057c.52-.52 1.365-.52 1.886 0L16 14.114l7.057-7.057c.486-.486 1.254-.518 1.778-.097l.108.097c.52.52.52 1.365 0 1.886L17.886 16l7.057 7.057c.486.486.518 1.254.097 1.778l-.097.108c-.52.52-1.365.52-1.886 0L16 17.886l-7.057 7.057c-.486.486-1.254.518-1.778.097l-.108-.097c-.52-.52-.52-1.365 0-1.886L14.114 16 7.057 8.943c-.486-.486-.518-1.254-.097-1.778z",
		transform: "translate(-1376 -32) translate(1376 32)"
	}) }) })
});
export default SvgIcCloseBold;
